/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Jun 09 2025
 **/

import { useMemo } from "react";

import { useInfiniteQuery } from "@tanstack/react-query";

import useActivityBookmarkActions from "./useActivityBookmarkActions";

export default function useActivityBookmarkListState() {
	const { fetch } = useActivityBookmarkActions();

	const query = useInfiniteQuery({
		queryKey: ["activity:bookmark"],
		queryFn: async ({ pageParam = undefined }) => {
			return await fetch(pageParam);
		},
		getNextPageParam: (lastPage) => {
			if (!lastPage?.hasNext || lastPage?.content.length === 0) return undefined;
			return lastPage?.content[lastPage?.content.length - 1].roomMessageId;
		},
		cacheTime: 0,
		staleTime: 0,
		enabled: true
	});

	const _roomMessageIds = query.data?.pages.flatMap((page) => page?.content.map((item) => item.roomMessageId)) ?? [];
	const roomMessageIds = useMemo(() => new Set(_roomMessageIds), [_roomMessageIds]);

	return {
		...query,
		roomMessageIds
	};
}
